import { colors } from '../../colors';
var form = {
  bgColor: colors.white,
  labelColor: colors.brightRed,
  errorColor: colors.warningRed,
  borderColor: colors.black,
  linkColor: colors.red,
  documentFormBgColor: colors.white,
  documentFormH4Color: colors.black,
  textColorDark: colors.black,
  textColorLight: colors.white
};
export default form;